import { Loading } from '@/components/loading/Loading';
import SchedulePanel from '@/components/phone/schedule';
import { Title } from '@/components/phone/Title';
import { useCurrentUser } from '@/hooks';
import { getOneDaySchedules } from '@raysee/firestore';
import dayjs from 'dayjs';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useState } from 'react';
import useSWR from 'swr';
import { Container, Footer, Header, Main, TabMenu, withLayout } from '../../../components';

const getOneWeek = () => {
  const oneWeekDays: Date[] = [];
  for (let i = 0; i < 7; i++) {
    oneWeekDays.push(dayjs().add(i, 'day').startOf('day').toDate());
  }
  return oneWeekDays;
};

const Page: NextPage = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(getOneWeek()[0]);
  const { user } = useCurrentUser();
  const { data, isLoading } = useSWR(
    ['schedules', selectedDate],
    () => getOneDaySchedules(selectedDate),
    { revalidateOnMount: true, revalidateOnFocus: false },
  );

  return withLayout(
    <Container>
      <NextSeo
        title="占い師の待機スケジュール一覧｜電話占いRAYSEE｜4,200円分無料、1分220円~｜口コミで当たると評判の電話レイシー"
        description="当日から7日間までの電話占い師待機スケジュールの一覧です。"
      />
      <Header />
      <Main>
        <div className="py-3 space-y-10 shadow-md shadow-[#a866c9]">
          <Title title="待機スケジュール" isCenter />
          <div className="px-4 flex overflow-x-scroll whitespace-nowrap ">
            {getOneWeek().map((date) => (
              <button
                type="button"
                className={`${
                  dayjs(selectedDate).isSame(date, 'day') ? 'bg-phone-primary' : 'bg-[#a866c9]'
                } text-white mx-1 py-2 px-3 rounded-md inline-flex items-center justify-center flex-1`}
                key={date.getTime()}
                onClick={() => {
                  setSelectedDate(date);
                }}
              >
                {dayjs(date).format('MM月DD日')}
              </button>
            ))}
          </div>
        </div>
        <div className="p-4 space-y-5">
          <div className="text-xs text-gray-500 font-serif font-bold ">
            <div>色付き枠が待機中の時間です。</div>
            <div>数字をタップするとその時間に待機している占い師を一覧で確認できます。</div>
            <div>またスケジュール表示は左右にフリックして全時間確認できます。</div>
          </div>
          {isLoading ? (
            <Loading size={12} color="border-t-rose-400" />
          ) : (
            <SchedulePanel schedules={data} targetDate={selectedDate} />
          )}
        </div>
        <Footer />
      </Main>
      <TabMenu isLogin={!!user} />
    </Container>,
  );
};

export default Page;
